// Animated gif
var AnimatedGif = {

    selector: '[data-gif]',
    selectorText: '[data-gif-text]',
    selectorImg: '[data-gif-img]',

    init: function () {

        if (!$(this.selector).length) return;

        this.bindClickOff();
    },

    bindClickOff: function () {

        $(AnimatedGif.selector).on('click', function (event) {

            var $thisContainer = $(this);
            var $thisImg = $thisContainer.find(AnimatedGif.selectorImg);

            var thisSelectorAttr = $thisImg.attr('data-gif-img');
            $thisImg.attr("src", thisSelectorAttr);

            AnimatedGif.addClassActive($thisContainer);

            event.preventDefault();

        });
    },

    addClassActive: function ($thisContainer) {
        $thisContainer.addClass('animation-off');
    }
}


$(document).ready(function () {

    AnimatedGif.init();

});
